// extracted by mini-css-extract-plugin
export var sectionReviews = "gh_pj";
export var sectionContent = "gh_qj";
export var textHeadingTop = "gh_rj";
export var textHeadingBottom = "gh_sj";
export var sliderContainer = "gh_tj";
export var cardWrapper = "gh_vj";